/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendSmsResponse
 */
export interface SendSmsResponse {
    /**
     * 
     * @type {string}
     * @memberof SendSmsResponse
     */
    recipientNumber: string;
    /**
     * 
     * @type {string}
     * @memberof SendSmsResponse
     */
    messageContent: string;
}

/**
 * Check if a given object implements the SendSmsResponse interface.
 */
export function instanceOfSendSmsResponse(value: object): value is SendSmsResponse {
    if (!('recipientNumber' in value) || value['recipientNumber'] === undefined) return false;
    if (!('messageContent' in value) || value['messageContent'] === undefined) return false;
    return true;
}

export function SendSmsResponseFromJSON(json: any): SendSmsResponse {
    return SendSmsResponseFromJSONTyped(json, false);
}

export function SendSmsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendSmsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'recipientNumber': json['recipientNumber'],
        'messageContent': json['messageContent'],
    };
}

export function SendSmsResponseToJSON(json: any): SendSmsResponse {
    return SendSmsResponseToJSONTyped(json, false);
}

export function SendSmsResponseToJSONTyped(value?: SendSmsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recipientNumber': value['recipientNumber'],
        'messageContent': value['messageContent'],
    };
}

